import { Stack, Typography } from '@mui/material'
import { DensityStyleTypes } from '../../../types'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import { renderColorByString } from 'components/DataGrid/renderColorByString'

interface ChildCategoryCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const ChildCategoryCell = ({ params, densityStyles }: ChildCategoryCellProps): React.ReactElement => {
  return (
    <Stack
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'left',
        width: '100%',
        height: '100%',
      }}
    >
      <Typography
        sx={{
          fontSize: densityStyles.fontSize,
          color: renderColorByString(params?.value),
          textAlign: 'center',
        }}
      >
        {params.value}
      </Typography>
    </Stack>
  )
}
export default ChildCategoryCell
